<template>
  <b-card no-body class="cpnt-aba" v-if="value !== null">
    <b-tabs content-class="mt-3" fill @input="cpntAbaOnChange">
      <b-tab v-for="(aba, index1) in cpntAbas" :key="'aba-' + index1" :active="cpntAbas[index1].chave === value" :disabled="aba.disabled === true" :style="aba.disabled === true ? 'cursor: no-drop;' : ''">
        <template slot="title">
          <div>
            <!-- SETA O NOME DA ABA -->
            <slot name="titulo" v-bind:cpntAba="cpntAbas[index1]" v-bind:indexA="cpntAbas[index1].chave">
              <span v-html="aba.nome"></span>
            </slot>
  
            <!-- VERIFICA O STATUS DA PRE-NOTA -->
            <span class="icones" v-if="[ '', null, undefined ].indexOf(aba.icone) === -1">
              <RF-Icones :title="aba.icone.titulo"
                :cpntId='cpntId + "-icone-" + index1'
                :cpntIcone='aba.icone.tipo'
                :cpntIconeClass='aba.icone.class'
              ></RF-Icones>
            </span>

            <span class="icones" v-if="([ '', null, undefined ].indexOf(aba.success) === -1 && aba.success.qtde >= 1) || ([ '', null, undefined ].indexOf(aba.alertas) === -1 && aba.alertas.qtde >= 1) || [ '', null, undefined ].indexOf(aba.erros) === -1 && aba.erros.qtde >= 1">
              <App-Icone v-if="[ '', null, undefined ].indexOf(aba.success) === -1 && aba.success.qtde >= 1" 
                :cpntTipo='"check-verde"'
                :title="aba.success.mensagem"
              ></App-Icone>

              <App-Icone v-if="[ '', null, undefined ].indexOf(aba.alertas) === -1 && aba.alertas.qtde >= 1" 
                :cpntTipo='"alerta-amarelo"'
                :title="'Foi encontrado ' + aba.alertas.qtde + ' alerta' + (aba.alertas.qtde >= 2 ? 's' : '') + '\n\n' + aba.alertas.mensagem"
              ></App-Icone>

              <App-Icone v-if="[ '', null, undefined ].indexOf(aba.erros) === -1 && aba.erros.qtde >= 1" 
                :cpntTipo='"erro-vermelho"'
                :title="'Foi encontrado ' + aba.erros.qtde + ' alerta' + (aba.erros.qtde >= 2 ? 's' : '') + '\n\n' + aba.erros.mensagem"
              ></App-Icone>
            </span>
          </div>
        </template>
      </b-tab>

      <!-- SETA O BOTÃO PARA ADICIONAR NOVA ABA -->
      <template #tabs-end>
        <b-nav-item role="presentation" @click="() => { cpntOnNewTab() }" v-if="cpntOnNewTab !== null" class="cpnt-aba-new-tab">
          <RF-Icones :cpntIcone='"ico-mais"'></RF-Icones>
        </b-nav-item>
      </template>
    </b-tabs>

    <div class="conteudo-abas" v-if="Object.keys($slots).indexOf('conteudo') !== -1">
      <div>
        <slot name="conteudo"></slot>
      </div>
    </div>
  </b-card>
</template>

<style scoped>
  .conteudo-abas > div {
    background: #fff;
    padding: 10px;
  }
</style>

<style>
:not(.app-dialog-header-abas) > .conteudo-abas > div {
  border: 1px solid #dee2e6;
  border-top: 0px;
  min-height: 300px;
}
.cpnt-aba-new-tab > a > span > svg {
  vertical-align: middle;
  height: 20px;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: .5rem 1rem;
}

.nav-link:focus,.nav-link:hover {
  text-decoration: none;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: .25rem;
/* border-top-right-radius:.25rem; */;
}

.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.cpnt-aba > .tabs > div > ul > li > a {
  color: #495057;
  font-weight: normal;
  min-height: 46px;
}
.cpnt-aba > .tabs > div > ul > li > a.active {
  font-weight: 600;
}
.cpnt-aba > .tabs > div > ul > li > a.disabled {
  cursor: no-drop;
  background: #f6f6f6;
}
.cpnt-aba > .tabs > div > ul > li > a > div > .icones > span > img {
  margin-left: 4px;
}
</style>

<script>
  // IMPORTA OS COMPONENTS
  import { BTabs, BTab, BCard, BNavItem } from 'bootstrap-vue'

  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'dialog-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntAbas: {
        required: true,
        type: Array
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },

      cpntOnChange: {
        required: true
      },
      cpntOnNewTab: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'b-tabs': BTabs,
      'b-tab': BTab,
      'b-card': BCard,
      'b-nav-item': BNavItem
    },
    data: function () {
      return {
        value: null
      }
    },
    mounted: function () {
      this.cpntAbaIniciar()
    },
    methods: {
      cpntAbaIniciar: function () {
        setTimeout(() => {
          // PEGA A CAHVE DO CAMPO
          var index = this.cpntAbas.findIndex(item => item.chave === this.cpntValue)

          // SETA A PRIMEIRA ABA COMO SELECIONADA
          if (index === -1 && this.cpntAbas.length >= 1) {
            index = 0
          }

          // SETA O NOVO VALOR DO CAMPO
          this.value = this.cpntAbas[index].chave

          // VERIFICA SE DEVE ATUALIZAR O CAMPO
          if (this.cpntValue !== this.value) {
            this.cpntAbaOnChange(index)
          }
        }, 0)
      },
      cpntAbaOnChange: function (index) {
        // SETA A PRIMEIRA ABA SOLICITADA
        var value = ([ '', null, undefined, -1, NaN ].indexOf(index) === -1 || isNaN(index) === false) ? this.cpntAbas[index].chave : this.cpntAbas[0].chave

        // VERIFICA SE DEVE ATUALIZAR O PAI
        if (value !== this.cpntValue) {
          this.cpntOnChange(value, this.cpntId)
        }
      },
    },
    watch: {
      cpntValue: function () {
        this.cpntAbaIniciar()
      }
    }
  }
</script>
